import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Calendar from 'react-calendar'
import { Svg } from '../../1_Atoms/Svg/Svg';
import Radio from '../../1_Atoms/Forms/Radio/Radio';
import Button from '../../1_Atoms/Button/Button';
import generalController from '../../../controllers/generalController';
import { languageController } from '../../../controllers/language/languageController';

function DateAndTimeSelector({
  onSubmit, isService, onGoBack
}) {
  
  const [today, setToday] = useState(new Date());
  const [futureDay, setFutureday] = useState(0);

  const morningLabel = languageController.getCopy('global', 'morning')
  const afternoonLabel = languageController.getCopy('global', 'afternoon')
  const eveningLabel = languageController.getCopy('global', 'evening')

  const [dateAndTime, setDateAndTime] = useState({
    date: today,
    time: 'morning',
  })

  const timeArr={
    morning: false, 
    afternoon: false, 
    evening: false
  }
  let timeArrNew = timeArr;

  const [timesAllowed, setTimesAllowed] = useState(timeArr);

  const hoursArr = isService ? JSON.parse(localStorage.getItem('dealerSelectedByUser')).hours.service : JSON.parse(localStorage.getItem('dealerSelectedByUser')).hours.sales;
  hoursArr.unshift(hoursArr.pop());

  function checkDefDay(defDay){
    const currWeekday =  defDay.getDay();

    if(new Date().toLocaleDateString() === today.toLocaleDateString() ){
      if(hoursArr[currWeekday].closed < (new Date().getHours() *100)){
        setNextDay(defDay, 1);
      }
      if(isService && hoursArr[today.getDay()].closed > today.getHours() * 100){
        setNextDay(today, 2);
      }else{
        setNextDay(today, 2.5);
      }
    }else if(Number(hoursArr[currWeekday].closed) === 0){
      setNextDay(defDay, 1);
    }
    if(hoursArr[defDay.getDay()].closed < 1801){
        timeArrNew.evening = true;
    }else{
      timeArrNew.evening = false;
    }
    if(hoursArr[defDay.getDay()].closed < 1201){
      timeArrNew.afternoon = true;
    }
    if(hoursArr[defDay.getDay()].open > 1159){
      timeArrNew.morning = true;
    }
  }
  function setNextDay(defDay, numDays){
    setFutureday(numDays);
    defDay.setTime(defDay.getTime() + (numDays * 24 * 60 * 60 * 1000));
    setToday(defDay);
    setDateAndTime({ ...dateAndTime, date: defDay });
    newDateTime(null, today);
  }

  checkDefDay(today);

  function newDateTime(e, value){
    if(value===undefined){
      setDateAndTime({ ...dateAndTime, time: e.target.value });
    }else{
      setDateAndTime({ ...dateAndTime, date: value });
      setTimesAllowed(timeArr)
      timeArrNew = timeArr;
      if(hoursArr[value.getDay()].closed < 1801){
        if(dateAndTime.time === 'evening') setDateAndTime({ ...dateAndTime, time: 'afternoon' });
        timeArrNew.evening = true;
      }
      if(hoursArr[value.getDay()].closed < 1201 || (isService && today.getHours() > 16 && futureDay < 2)){
        if(dateAndTime.time === 'afternoon') setDateAndTime({ ...dateAndTime, time: 'morning' });
        timeArrNew.afternoon = true;
      }
      if(hoursArr[value.getDay()].open > 1159 || (isService && today.getHours() > 11 && futureDay < 2)){
        if(dateAndTime.time === 'morning') setDateAndTime({ ...dateAndTime, time: 'afternoon' });
        timeArrNew.morning = true;
      }
      setTimesAllowed(timeArrNew);
    }
    
  }

  return (
    <div className="mz-date-and-time-selector">
      <div className="mz-container">
        <div className="mz-full-width mz-date-and-time-selector__inner">

          <div className="mz-date-and-time-selector__main">
            <div className="mz-date-and-time-selector__calendar">
              <Calendar
                className="mz-calendar"
                calendarType="US"
                defaultValue={today}
                minDate={today}
                maxDate={new Date(new Date().setFullYear(today.getFullYear() + 1))} // one year from now
                minDetail="month"
                nextLabel={<Svg type="chevron_small" size={1.1} colour="grey" />}
                nextAriaLabel="Go to next month"
                prevLabel={<Svg type="chevron_small" size={1.1} colour="grey" rotation="180" />}
                prevAriaLabel="Go to previous month"
                locale={generalController.detectLanguage() === 'fr' ? 'fr-CA' : "en-US"} // en-US or fr-CA
                onClickDay={(value, e) => newDateTime(e, value)}
                tileDisabled={({ date }) => date.getDay() === hoursArr.findIndex((entry, index)=> index === date.getDay() && entry.open === 0)}
              />
            </div>
            <div className="mz-date-and-time-selector__form">
              <div className="mz-date-and-time-selector__time">
                <Radio
                  label={morningLabel}
                  name={"morning"}
                  value={"morning"}
                  checked={(dateAndTime.time === "morning")}
                  onChange={(e) => newDateTime(e)}
                  isDisabled={timesAllowed.morning}
                />
                <Radio
                  label={afternoonLabel}
                  name={"afternoon"}
                  value={"afternoon"}
                  checked={(dateAndTime.time === "afternoon")}
                  onChange={(e) => newDateTime(e)}
                  isDisabled={timesAllowed.afternoon}
                />
                <Radio
                  label={eveningLabel}
                  name={"evening"}
                  value={"evening"}
                  checked={(dateAndTime.time === "evening")}
                  onChange={(e) => newDateTime(e)}
                  isDisabled={timesAllowed.evening}
                />
              </div>
              <Button
                label={languageController.getCopy('global', 'continue')}
                className="mz-btn--red mz-date-and-time-selector__submit"
                buttonIcon={<Svg type="chevron_small" size={0.75} colour="white" />}
                buttonIconPosition="right"
                onClick={() => onSubmit(dateAndTime)}
              />
              {onGoBack ? 
              <Button
                label={languageController.getCopy('global', 'backToSummary')}
                className="mz-btn--red mz-date-and-time-selector__goback"
                onClick={() => onGoBack()}
              /> : null }
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

DateAndTimeSelector.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default DateAndTimeSelector
